import Vuex from 'vuex'
import Vue from 'vue'
import Router from 'vue-router'
import VueResource from 'vue-resource'
import UsersModule from './module/UserModule.js'
// 引入 axios
import axios from 'axios'

Vue.use(Vuex)
Vue.use(Router)
Vue.use(VueResource)
export default new Vuex.Store({
modules: {
	users: UsersModule    
},
state: {
  myCount: 3
},
mutations: {
    
},
actions: {
	// 封装一个 ajax 方法
 	
}
})



// WEBPACK FOOTER //
// ./src/store/store.js